import { mbToBytes } from '@/utils/media.js'

export const TUS_OPTIONS = {
  chunkSize: mbToBytes(5),
  parallelUploads: 1,
  removeFingerprintOnSuccess: true,
  retryDelays: [0, 1000, 3000, 5000, 10000],
  storeFingerprintForResuming: false,
}

export const UPLOAD_WATERMARK = 'a7733d2bf10f770c1813712b6e0b05a7'
export const UPLOAD_ALLOWED_ORIGINS = [
  'localhost:3000',
  '127.0.0.1.sslip.io:3000',
  'go.promeet.live',
  'go-dev.promeet.pro',
  'go-dev-jay.promeet.pro',
  'go-dev-steve.promeet.pro',
  'go-dev-sergiu.promeet.pro',
]

export const UPLOAD_KEYS = {
  VIDEO_CONTENT: 'videoContent',
  VIDEO_PREVIEW: 'videoPreview',
}
